import { useLazyQuery, useMutation } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { PageContext } from '../../../lib/context';
import queries from '../../../utils/gql/queries';
import mutations from '../../../utils/gql/mutations';
import AdditionalFeesView from './additional-fees';
import { EditOutlined } from '@ant-design/icons';
import { Form, message, Space, Tooltip, Button } from 'antd';

interface AddFees {
  id: number;
  title: string;
  mode_of_payment: string;
  number_of_months: number;
  created_at: Date;
  updated_at: Date;
  amount: number;
}

interface AddFeesUpdate {
  id: number;
  title: string;
  mode_of_payment: string;
  number_of_months: string;
  amount: number;
}

const AdditionalFeesController = () => {
  const [form] = Form.useForm();
  const [addFees, setAddFees] = useState<AddFees[]>([]);
  const [show, setShow] = useState<boolean>(false);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [getAddFees, { data: addfees_data, loading }] = useLazyQuery(
    queries.GET_ADDFEES,
    {
      fetchPolicy: 'no-cache',
    }
  );

  const [insertUpdateFees] = useMutation<AddFeesUpdate>(
    mutations.INSERT_UPDATE_ADDITIONAL_FEES,
    {
      onCompleted(res) {
        message.success('Data added successfully.');
        _getAddFees();
        form.resetFields();
        setShow(false);
        setShowForm(false);
        form.resetFields();
      },
      onError({ graphQLErrors }) {
        console.log(graphQLErrors);
        message.error('Something is wrong');
      },
    }
  );

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Title',
      key: 'title',
      dataIndex: 'title',
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
    },
    {
      title: 'Mode of Payment',
      dataIndex: 'mode_of_payment',
      key: 'mode_of_payment',
    },
    {
      title: 'Number of Months',
      key: 'number_of_months',
      dataIndex: 'number_of_months',
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: { key: React.Key }) => (
        <Space>
          <Tooltip title="Edit">
            <Button type="link" onClick={_showEditHandler(record)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          {/* <Tooltip title="Delete">
                        <Button type="link">
                            <DeleteOutlined />
                        </Button>
                    </Tooltip> */}
        </Space>
      ),
    },
  ];

  const _showEditHandler = (data: any) => {
    if (data.mode_of_payment === 'Installment') {
      return () => {
        form.setFieldsValue(data);
        _showHandler();
        setDisplay(false);
      };
    } else {
      return () => {
        form.setFieldsValue(data);
        _showHandler();
        setDisplay(true);
      };
    }
  };

  const handleChange = (value: string) => {
    if (value === 'Installment') {
      setDisplay(false);
    } else {
      setDisplay(true);
    }
  };
  const handleMonthChange = (value: string) => {
    // console.log(selected ${value});
  };

  const _onFinish = (data: AddFeesUpdate) => {
    insertUpdateFees({
      variables: {
        data,
      },
    });
  };

  const _getAddFees = () => {
    getAddFees();
  };

  useEffect(() => {
    _getAddFees();
  }, [getAddFees]);

  useEffect(() => {
    if (addfees_data) {
      const items = addfees_data.additional_fees.map((id: AddFees) => {
        return {
          ...id,
        };
      });
      setAddFees(items);
    }
  }, [addfees_data]);

  const _submitHandler = () => {
    form.submit();
  };

  const _showHandler = () => {
    setShowForm(true);

    setShow(true);
    // form.resetFields()
  };

  const _closeHandler = () => {
    setShow(false);
    setShowForm(false);
    form.resetFields();
  };

  const value: object = {
    form,
    show,
    columns,
    addFees,
    showForm,
    visible,
    display,
    loading,
    handleChange,
    handleMonthChange,
    _showHandler,
    _closeHandler,
    _submitHandler,
    _onFinish,
    setVisible,
  };

  return (
    <PageContext.Provider value={value}>
      <AdditionalFeesView />
    </PageContext.Provider>
  );
};

export default AdditionalFeesController;
